import React, { useState } from 'react';
import { Card, Box, Divider, CardContent, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import './LeaveTypes.css';
import { DialogBoxComponent } from '../../../../components/DialogBox/DialogBoxCard';
import LeaveTypeForm from './LeaveTypeForm/LeaveTypeForm';
import { CANCEL_BUTTON_TEXT, DELETE_BUTTON_TEXT } from '../../../../constants';

const DeletePromptContent = () => {
  return (
    <>
      <Typography variant="body1" style={{ color: 'red' }}>
        Deleting this leave type will remove it from the coming years.
      </Typography>
    </>
  );
};

const LeaveTypeCard = (props) => {
  const {
    leaveType,
    deleteLeaveType,
    unUsedColor,
    leaveTypesList,
    refresh,
    setRefresh,
    selectedYear,
  } = props;

  const [open, setOpen] = useState(false);
  const [openDeletePrompt, setOpenDeletePrompt] = useState(false);

  const onEditClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeletePromptClose = () => {
    setOpenDeletePrompt(false);
  };

  const onDeleteClick = () => {
    setOpenDeletePrompt(true);
  };

  const onConfirmDelete = () => {
    deleteLeaveType(leaveType.id);
  };

  const cardStyles = {
    borderRadius: 12,
    minWidth: 100,
    textAlign: 'center',
    boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.08)',
    margin: '20px',
  };

  const headingStyles = {
    fontSize: 18,
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    marginTop: 8,
    marginBottom: 0,
  };

  const subheaderStyles = {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.54)',
  };

  const borderedGridStyles = {
    borderColor: 'rgba(0, 0, 0, 0.08)',
    height: '50%',
  };

  return (
    <Card style={cardStyles}>
      <>
        <CardContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: leaveType.color,
            }}
          />
          <h3 style={headingStyles}>{leaveType.leaveName}</h3>
          <span style={subheaderStyles}>
            Number of days: {leaveType.numberOfDays}
          </span>
          <span style={subheaderStyles}>
            Maximum carry forward leave:
            {leaveType.maxCarryForwardLeavesAllowed}
          </span>
          <span style={subheaderStyles}>
            Maximum Encashment leave:
            {leaveType.maxEncashmentLeavesAllowed}
          </span>
        </CardContent>
        <Divider light />
        <Box display={'flex'}>
          <Box p={2} flex={'auto'} style={borderedGridStyles}>
            <EditIcon
              color="primary"
              className="action-icon-cursor"
              onClick={() => onEditClick()}
            />
          </Box>
          <Box p={2} flex={'auto'} style={borderedGridStyles}>
            <DeleteIcon
              sx={{ color: '#9c27b0', marginLeft: '10px' }}
              className="action-icon-cursor"
              onClick={() => onDeleteClick()}
            />
          </Box>
        </Box>
        <DialogBoxComponent
          open={open}
          fullWidth={true}
          handleClose={handleClose}
          component={
            <LeaveTypeForm
              type={'update'}
              data={leaveType}
              refresh={refresh}
              setRefresh={setRefresh}
              unUsedColor={unUsedColor}
              leaveTypesList={leaveTypesList}
              handleFormClose={handleClose}
              selectedYear={selectedYear}
              setOpenForm={setOpen}
            />
          }
        />
        <DialogBoxComponent
          open={openDeletePrompt}
          fullWidth={true}
          handleClose={handleDeletePromptClose}
          title={'Are you sure you want to delete this leave type?'}
          content={<DeletePromptContent />}
          onCancel={handleDeletePromptClose}
          cancelText={CANCEL_BUTTON_TEXT}
          onConfirm={onConfirmDelete}
          confirmText={DELETE_BUTTON_TEXT}
        />
      </>
    </Card>
  );
};

export default LeaveTypeCard;
